module.exports = __webpack_public_path__ + "static/media/wooCommerceCard.86138e82.png";